import { render, staticRenderFns } from "./onebox-registerbusiness.vue?vue&type=template&id=75f22e19&scoped=true&"
import script from "./onebox-registerbusiness.vue?vue&type=script&lang=js&"
export * from "./onebox-registerbusiness.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75f22e19",
  null
  
)

export default component.exports